import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useCreateTimeClockMutation } from 'queries/admin/timeClock'

type CreateTimeClockFlowContextState = {
  state: {
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    submit: ReturnType<typeof useCreateTimeClockMutation>['mutate']
    reset: ReturnType<typeof useCreateTimeClockMutation>['reset']
  }
}

const [Context, useCreateTimeClockFlowContextValue] =
  createContext<CreateTimeClockFlowContextState>({
    name: 'CreateTimeClockFlowContext',
  })

export const CreateTimeClockFlowProvider = ({
  children,
}: PropsWithChildren) => {
  const { mutate, reset, isPending, isError, error } =
    useCreateTimeClockMutation()

  const value: CreateTimeClockFlowContextState = {
    state: {
      mutationState: {
        isPending,
        isError,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: {
      submit: mutate,
      reset,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useCreateTimeClockFlowContextValue }
